import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4beae93f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-head login-head__background" }

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginHead',
  props: {
  hasBack: {
    type: Boolean,
    default: false
  }
},
  emits: ["back"],
  setup(__props, { emit: emits }) {





function onClick() {
  emits("back");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.hasBack)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "login-head__back",
          onClick: onClick
        }, [
          _createVNode(FeatherIcon, { icon: "chevron-left" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})